import Vue from "vue";
import App from "./App.vue";

import "./assets/scss/app.scss";

import router from "./router";
import store from "./store";
import ErrorService from "./utils/ErrorService";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { rtdbPlugin } from "vuefire";
import Vuelidate from "vuelidate";
import GmapVue from "gmap-vue";
import IdleVue from "idle-vue";
import Component from "vue-class-component";

Vue.config.productionTip = false;

Vue.config.errorHandler = (error) => ErrorService.onError(error);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(IdleVue, { idleTime: 1800000, store });
Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_MAPS_DEV_KEY || "",
    libraries: "places, geometry",
  },
  installComponents: true,
});
Vue.use(Vuelidate);
Vue.use(rtdbPlugin);

Component.registerHooks(["beforeRouteLeave"]);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
